export var TaskType;
(function (TaskType) {
    TaskType["veiligheid"] = "veiligheid";
    TaskType["organisatie"] = "organisatie";
    TaskType["magazijn"] = "magazijn";
    TaskType["onderhoud"] = "onderhoud";
    TaskType["obs"] = "obs";
    TaskType["assetData"] = "assetData";
    TaskType["productie"] = "productie";
    TaskType["revisie"] = "revisie";
    TaskType["storing"] = "storing";
    TaskType["incident"] = "incident";
    TaskType["internalMiscellaneous"] = "internalMiscellaneous";
})(TaskType || (TaskType = {}));
